module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }